"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
const AvatarDoesNotExistError_1 = __importDefault(require("./errors/AvatarDoesNotExistError"));
const AvatarNotPermittedError_1 = __importDefault(require("./errors/AvatarNotPermittedError"));
class AvatarsServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
    }
    async pickAvatar(avatarId) {
        const url = `${this.url}/api/avatars`;
        const expectedResponses = [200, 403, 422];
        const response = await this.requestMaker.makeRequest(url, {
            method: 'POST',
            body: JSON.stringify({ avatarId })
        }, expectedResponses);
        if (response.status === 403) {
            throw new AvatarNotPermittedError_1.default(avatarId);
        }
        if (response.status === 422) {
            throw new AvatarDoesNotExistError_1.default(avatarId);
        }
        return response.json;
    }
    async fetchAllAvatars() {
        const url = `${this.url}/api/avatars`;
        const expectedResponses = [200];
        const response = await this.requestMaker.makeRequest(url, {
            method: 'GET'
        }, expectedResponses);
        return response.json;
    }
    async adminAddRandomAvatarForUser(userId) {
        const url = `${this.url}/api/admin/user-avatar`;
        const expectedResponses = [200, 404];
        const response = await this.requestMaker.makeRequest(url, {
            method: 'POST',
            body: JSON.stringify({ userId })
        }, expectedResponses);
        if (response.status === 404) {
            throw new Error('No more avatars to add');
        }
        return response.json;
    }
}
exports.default = AvatarsServiceClient;
//# sourceMappingURL=AvatarsServiceClient.js.map